import { refuseInsecurePage } from '../../shared/https-only.js'
import { accountOriginFromLocation, apiFromLocation } from '../../shared/designer-host.js'

if (refuseInsecurePage(window.document, window.location)) {

  throw new Error('HTTPS is required')
}

const fromHost = accountOriginFromLocation(window.location)
const params = new URLSearchParams(window.location.search)
const fromQuery = params.get('api')

if (!fromHost && fromQuery) {

  window.sessionStorage.setItem('superturboApi', fromQuery)
}

const api = apiFromLocation(
  window.location,
  fromHost ? '' : window.sessionStorage.getItem('superturboApi')
)

window.__SUPERTURBO_API__ = api
window.__SUPERTURBO_WS__ = api.replace(/^http/, 'ws')
